<template>
  <svg width="40" height="40" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.95">
      <path d="M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V30C36 33.3137 33.3137 36 30 36H6C2.68629 36 0 33.3137 0 30V6Z" fill="#171717"/>
      <path d="M11.2 9.70008L14.9528 16.2004H8V19.6005H15.1027L11.235 26.2999L14.1795 28L17.9722 21.4305L21.765 28L24.7095 26.2999L20.8418 19.6005H28V16.2004H20.9917L24.7445 9.70008L21.8 8L17.9722 14.6302L14.1445 8L11.2 9.70008Z" fill="#F7F7F7"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
